module.exports = __webpack_public_path__ + "static/media/key.0a9befa4.svg";